import { toast } from 'react-toastify';

export function messageSuccess(message, options) {
  toast.success(message, options);
}
export function messageError(message) {
  toast.error(message);
}
